import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const uploadObjectivesCSVApi = (data) => {
  const url = endpoints.admin.bulkUploadObjectives;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

export const uploadKeyResultsCSVApi = (data) => {
  const url = endpoints.admin.bulkUploadKeyResults;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

export const uploadOKRCSVApi = (data) => {
  const url = endpoints.admin.bulkUploadOKR;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

export const bulkUploadOKRSampleFileApi = async (queryParams) => {
  const url = endpoints.admin.bulkUploadOKRSampleFile;
  try {
    const res = await sendRequest({
      url,
      method: 'GET',
      credentials: 'include',
      queryParams,
    });
    const blob = await res?.blob();

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download =
      queryParams?.sampleType === 'BASIC'
        ? 'bulk_upload_basic_sample_file.csv'
        : 'bulk_upload_detailed_sample_file.csv';
    link.click();
  } catch (err) {
    console.error('Error downloading the csv', err);
  }
};

export const uploadObjectivesCSV = (fileObject) => {
  const data = new FormData();
  data.append('file', fileObject);
  data.append('type', 'OBJECTIVE_UPLOAD');
  return uploadObjectivesCSVApi(data);
};

export const uploadKeyResultsCSV = (fileObject) => {
  const data = new FormData();
  data.append('file', fileObject);
  data.append('type', 'GOAL_UPLOAD');
  return uploadKeyResultsCSVApi(data);
};

export const uploadOKRCSV = (fileObject, timeBoundObject) => {
  const data = new FormData();
  data.append('file', fileObject);
  const timeBoundBlob = new Blob([JSON.stringify(timeBoundObject)], { type: 'application/json' });
  data.append('timeBound', timeBoundBlob);
  return uploadOKRCSVApi(data);
};

export const downloadBulkUploadOKRSampleFile = ({ sampleType = 'BASIC' }) => bulkUploadOKRSampleFileApi({ sampleType });
